module.exports = __webpack_public_path__ + "static/media/signup-background.defe3fd2.jpg";